import { render, staticRenderFns } from "./GeneralChartComponent.vue?vue&type=template&id=67cc462f&"
import script from "./GeneralChartComponent.vue?vue&type=script&lang=js&"
export * from "./GeneralChartComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports